import HealthService from '../services/apiRequests/health.service';
import router from '../router';
import { cloneObject } from '@/utils';

export default {
    namespaced: true,
    state: {
        isSystemInMaintenance: false
    },
    getters: {},
    mutations: {
        setSystemInMaintenance(state, isSystemInMaintenance) {
            state.isSystemInMaintenance = isSystemInMaintenance;
        }
    },
    actions: {
        async getSystemStatus({ commit }) {
            await HealthService.getSystemStatus();
        },
        changeSystemStatus({ commit, state }) {
            if (!state.isSystemInMaintenance) {
                commit('setSystemInMaintenance', true);
                let lastLocation = cloneObject(window.location);
                // Если в адресной строке уже есть сохраненный query - redirectToPath
                let query = decodeURIComponent(lastLocation.search).split('=')[1];
                // если этого query нет, сохраняем новый
                if (!query) query = lastLocation.pathname;
                const redirectPath = query ? query : router.currentRoute.fullPath;
                router.push({ name: 'MaintenanceWorks', query: { redirectToPath: redirectPath } });
            }
        }
    }
};
